module.exports = __webpack_public_path__ + "img/hasbi-mauriza-hasyim.f529ee08.jpg";